import { VStack } from '@chakra-ui/react'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@missionlabs/react'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useMeasure } from 'react-use'
import { Features, useHasClientFeature } from 'shared/hooks/useHasClientFeature'
import { useGetPortingFormURLsQuery } from 'shared/store'
import { isPhoneLinePlus } from 'shared/utils/env'

import MirrorNumberForm from './Mirror'
import PortNumberForm from './Port'

export const ExistingNumberForm: FC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    const isMirroringClientEnabled = useHasClientFeature(Features.mirroring)
    const isPortingClientEnabled = useHasClientFeature(Features.porting)

    const [tabHeadersRef, { height: tabHeaderHeight }] = useMeasure()

    useGetPortingFormURLsQuery()

    const onClose = useCallback(() => {
        navigate('..')
    }, [navigate])

    const { type } = useParams()

    const onChangeTab = useCallback(
        (tabIndex: number) => {
            const mirroringRoute = isPhoneLinePlus ? 'present' : 'mirror'
            navigate(`/admin/numbers/existing/${tabIndex === 0 ? 'port' : mirroringRoute}`)
        },
        [navigate]
    )

    if (!isPortingClientEnabled && !isMirroringClientEnabled) {
        return null
    }

    const mirroringTitle = isPhoneLinePlus
        ? 'admin.numbers.mirror.headerPhoneLinePlus'
        : 'admin.numbers.mirror.header'

    return (
        <VStack h="full" spacing="32px" align="stretch" justify="space-between" overflow={'hidden'}>
            <Tabs
                size="md"
                h="full"
                isFitted
                isLazy
                index={type === 'port' || !isPortingClientEnabled ? 0 : 1}
                onChange={onChangeTab}
            >
                <TabList ref={tabHeadersRef}>
                    {isPortingClientEnabled && <Tab>{t('admin.numbers.porting.header')}</Tab>}
                    {isMirroringClientEnabled && <Tab>{t(mirroringTitle)}</Tab>}
                </TabList>
                <TabPanels h={`calc(100% - ${tabHeaderHeight}px)`}>
                    {isPortingClientEnabled && (
                        <TabPanel h={'full'}>
                            <PortNumberForm onClose={onClose} />
                        </TabPanel>
                    )}
                    {isMirroringClientEnabled && (
                        <TabPanel h={'full'}>
                            <MirrorNumberForm onClose={onClose} />
                        </TabPanel>
                    )}
                </TabPanels>
            </Tabs>
        </VStack>
    )
}
